import { PublicFormPersistedState } from './publicformpersistedstate-types';

// these defaults only get used/set if the public form has no persisted state
const defaults: PublicFormPersistedState = {};

export default defaults;
